import { CommonCardCounter } from "../common-card-counter/index.js";

export function ProductCardCounter(productCardEl) {
    CommonCardCounter.apply(this, arguments);
}
